// @ts-nocheck
 
 
 
 
 
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import */
/* eslint-disable @typescript-eslint/no-unused-vars */
 
 
/* eslint-disable react/jsx-newline */
 
 
 
 
 
import { useDispatch } from 'react-redux';
import { Link, useHistory, useRouteMatch } from 'react-router-dom';
  import React, { Fragment, useEffect, useRef, useState , Suspense } from 'react'
  
 // import "../style.css";
import { useIntl } from 'react-intl';
import PaidIcon from '@mui/icons-material/Paid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Box ,CircularProgress} from '@mui/material';
const TransactionTabs = ({tabsValue,handleChangeTabs}) => {
      const dispatch = useDispatch();
      const match = useRouteMatch();
      const intl = useIntl();

return(
    <Box  className='tabs-parent' sx={{fontSize:"15px",color:"white",fontFamily:"Cairo",padding:"1px", borderRadius:"6px", width: '94%',marginLeft:"30px",marginRight:"30px",marginBottom:"12px", bgcolor: '#363740' }}>
    <Tabs
      value={tabsValue}
      onChange={handleChangeTabs}
      centered
      sx={{
       '.MuiTabs-flexContainer': {
         justifyContent: 'space-around',

       },
       '.MuiTab-root': {
         width: '14%', // Set each tab to take a proportion
         maxWidth: 'none', // Override default maxWidth
         fontSize:"12px",color:"white",fontFamily:"Cairo",
       },
       '.Mui-selected': { // Styles for the selected tab
         color: '#5C636A', // Use secondary color for the selected tab
         fontWeight: 'bold', // Make the font bold for selected tab
         backgroundColor:"white",
         borderRadius:"6px",
         fontSize:"13px",
         fontFamily:"Cairo"
       },
     }}
     indicatorColor="white"
     textColor="white"
   >
 {/* v7.1: Eligibility tab removed — documents are user-level now (managed via user_eligibility API).
     Remaining tabs keep EXPLICIT values matching their original indices so the parent's
     index-based logic (getBaseUrlForTab / handleChangeTabs / render) is unchanged. */}
 <Tab value={0} className='trans-types-tabs-child' label={intl.formatMessage({ id: 'AccountStatement' })} />
 <Tab value={1} className='trans-types-tabs-child' label={intl.formatMessage({ id: 'tickets' })} />
 <Tab value={2} className='trans-types-tabs-child' label={intl.formatMessage({ id: 'charging' })} />
 <Tab value={5} className='trans-types-tabs-child' label={intl.formatMessage({ id: 'Selling' })} />
 <Tab value={6} className='trans-types-tabs-child' label={intl.formatMessage({ id: 'Offers' }) || "Offers"} />
 </Tabs>
 </Box>
   )
  
};

export { TransactionTabs };
